"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HoverTupleInteractionModel = exports.SelectTuplesInteractionModel = exports.SelectionModelsContainer = exports.TupleSelectionModel = exports.DimensionSelectionModel = exports.RangeSelectionModel = exports.HierarchicalSelectionModel = exports.ValueSelectionModel = exports.SelectionModel = void 0;
/**
 * Selection Model.
 */
class SelectionModel {
}
exports.SelectionModel = SelectionModel;
/**
 * Value based selection model. Meant for hierarchical, range and categorical selections.
 */
class ValueSelectionModel extends SelectionModel {
    constructor() {
        super(...arguments);
        this.selectValues = [];
    }
}
exports.ValueSelectionModel = ValueSelectionModel;
/**
 * Hierarchical value selection model
 */
class HierarchicalSelectionModel extends ValueSelectionModel {
}
exports.HierarchicalSelectionModel = HierarchicalSelectionModel;
/**
 * Range based value selection model
 */
class RangeSelectionModel extends SelectionModel {
}
exports.RangeSelectionModel = RangeSelectionModel;
/**
 * Dimension value selection model
 */
class DimensionSelectionModel extends ValueSelectionModel {
}
exports.DimensionSelectionModel = DimensionSelectionModel;
/**
 * Tuple based selection model
 */
class TupleSelectionModel {
    constructor() {
        this.objectIds = [];
    }
}
exports.TupleSelectionModel = TupleSelectionModel;
/**
 * Container class to populate all the selection models when parsing input
 */
class SelectionModelsContainer {
    constructor() {
        this.hierModelArr = [];
        this.dimModelArr = [];
        this.quantModelArr = [];
    }
}
exports.SelectionModelsContainer = SelectionModelsContainer;
class SelectTuplesInteractionModel {
    constructor(visualIdPresModel, tupleIds = [], selectOptions, tooltipContext) {
        this.visualIdPresModel = visualIdPresModel;
        this.tupleIds = tupleIds;
        this.selectOptions = selectOptions;
        this.tooltipContext = tooltipContext;
    }
}
exports.SelectTuplesInteractionModel = SelectTuplesInteractionModel;
class HoverTupleInteractionModel {
    constructor(visualIdPresModel, tupleId, tooltipContext, allowHoverActions) {
        this.visualIdPresModel = visualIdPresModel;
        this.tupleId = tupleId;
        this.tooltipContext = tooltipContext;
        this.allowHoverActions = allowHoverActions;
    }
}
exports.HoverTupleInteractionModel = HoverTupleInteractionModel;
//# sourceMappingURL=SelectionModels.js.map